import type { ReactNode } from 'react';

import { InboxIcon } from '../layout/icons';

export interface EmptyStateProps {
  title: string;
  description?: string;
  /** Glyph in place of the default mark - keeps one empty pattern across the panels. */
  icon?: ReactNode;
  action?: ReactNode;
  compact?: boolean;
}

export function EmptyState({ title, description, icon, action, compact = false }: EmptyStateProps) {
  return (
    <div className={compact ? 'empty-state empty-state--compact' : 'empty-state'}>
      <div className="empty-state__mark" aria-hidden={true}>{icon || <InboxIcon size={26} />}</div>
      <div className="empty-state__title">{title}</div>
      {description ? <p className="empty-state__description">{description}</p> : null}
      {action ? <div className="empty-state__action">{action}</div> : null}
    </div>
  );
}

export default EmptyState;
